import React, {ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import AnnotationRectangle from "./AnnotationRectangle";
import {
	Annotation,
	AnnotationPointPoint,
	AnnotationRectangle as MetadataAnnotationRectangle,
	AnnotationRectangleRectangle, Markup,
	Positions
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class SquigglyAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;

		let positions: Array<Positions> = FunctionHelper.applyValue(
			annotation.positions, Annotation.getPositionsDefault()
		);
		let result: Array<ReactNode> = [];

		for (let position of positions) {
			if (!FunctionHelper.exists((position as MetadataAnnotationRectangle).rectangle)) {
				continue;
			}

			let rectBoundaries: AnnotationRectangleRectangle =
				(position as MetadataAnnotationRectangle).rectangle!;
			let segmentWidth: number = 2;
			let segments: number = Math.floor(rectBoundaries.width! / segmentWidth);

			let border: Array<AnnotationPointPoint> = [];
			for (let j: number = 0; j < segments; j++) {
				border.push(AnnotationPointPoint.fromJson({
					x: j * (rectBoundaries.width! / segments),
					y: rectBoundaries.height! + (j % 2 === 0 ? 0 : segmentWidth)
				} as AnnotationPointPoint));
			}

			result.push(
				<AnnotationRectangle {...this.props} popupColor={color} {...rectBoundaries} key={result.length}
									 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
									 popupContent={annotation.contents} popupCreator={annotation.markup?.creator}
									 creationDate={annotation.markup?.creationDate}
									 style={{
										 zIndex: 0
									 }}>
					<svg xmlns={SVG_NAMESPACE}>
						<polyline points={border.map(point => point.x + "," + point.y).join(" ")}
								  style={{
									  opacity: opacity,
									  stroke: color
								  }}/>
					</svg>
				</AnnotationRectangle>
			);
		}

		return result;
	}
}